import { useEffect, useState } from "react";
import { toast } from "sonner";
import { TrendingUp, Loader2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

export const PortalImproveRequest = ({ studyId, score }) => {
  const [req, setReq] = useState(undefined);
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/portal/studies/${studyId}/improve-request`).then((r) => setReq(r.data)).catch(() => setReq(null)); }, [studyId]);
  const send = async () => {
    setBusy(true);
    try { const r = await api.post(`/portal/studies/${studyId}/improve-request`, { note }); setReq(r.data); setOpen(false); toast.success("Request sent. We'll email you when your updated study is ready."); }
    catch (e) { toast.error(errMsg(e, "Could not send request")); } finally { setBusy(false); }
  };
  if (req === undefined) return null;
  const pending = req && req.status !== "done";
  return (
    <section className="no-print rounded-xl border border-slate-800 bg-slate-900/70 p-6" data-testid="portal-improve-request">
      <h2 className="flex items-center gap-2 font-display text-lg font-semibold mb-1"><TrendingUp className="h-5 w-5 text-amber-400" />Improve my score</h2>
      {pending ? <p className="text-sm text-slate-300" data-testid="portal-improve-pending">Your improvement review was requested on {req.created_at?.slice(0, 10)}. Our team is working on it, and we'll email you when the updated study is ready.</p> : (
        <>
          <p className="text-sm text-slate-400 mb-4">{req?.status === "done" ? <span className="flex items-center gap-1 text-emerald-300 mb-2"><CheckCircle2 className="h-4 w-4" />Last review {req.new_score > req.score ? "raised" : "changed"} your score from {req.score} to {req.new_score}.</span> : null}
            Current score: <span className="num font-semibold text-slate-200">{score}</span>/100. Ask our analysts to find realistic plan changes that strengthen your project.</p>
          {open ? (
            <div className="space-y-3">
              <Textarea data-testid="portal-improve-note" rows={3} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Anything we should know? e.g. budget limits, parts of the plan you can change" className="bg-slate-950/60 border-slate-700" />
              <div className="flex gap-2"><Button data-testid="portal-improve-send" disabled={busy} onClick={send} className="rounded-full bg-amber-400 text-amber-950 hover:bg-amber-300">{busy && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}Send request</Button>
                <Button variant="ghost" onClick={() => setOpen(false)}>Cancel</Button></div>
            </div>
          ) : <Button data-testid="portal-improve-btn" onClick={() => setOpen(true)} className="rounded-full bg-amber-400 text-amber-950 hover:bg-amber-300"><TrendingUp className="h-4 w-4 mr-1" />Request a score improvement review</Button>}
        </>
      )}
    </section>
  );
};
